import { startRoutingEditSession } from '@/services/api/routing/routing'
import { startSpecializedRoutingEditSession } from '@/services/api/specialized-routing/specialized-routing'

let currentSessionId = null
const notifiedRoutingIds = new Set()

function generateUuid() {
  if (typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function') {
    return crypto.randomUUID()
  }
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
    const r = (Math.random() * 16) | 0
    const v = c === 'x' ? r : (r & 0x3) | 0x8
    return v.toString(16)
  })
}

export function startRoutingSession() {
  if (currentSessionId) return currentSessionId
  currentSessionId = generateUuid()
  return currentSessionId
}

export function endRoutingSession() {
  currentSessionId = null
  notifiedRoutingIds.clear()
}

export function getRoutingSessionId() {
  return currentSessionId
}

/**
 * Notifies the backend that an edit session has started for this routing.
 * Idempotent per (sessionId, routingId) — repeated calls during the same
 * session do not re-fire the API.
 */
export async function notifyRoutingEditStart(routingId) {
  if (!routingId) return null
  const sessionId = startRoutingSession()
  const key = `fixed:${sessionId}:${routingId}`
  if (notifiedRoutingIds.has(key)) return sessionId
  notifiedRoutingIds.add(key)
  try {
    await startRoutingEditSession(routingId, sessionId)
  } catch (err) {
    notifiedRoutingIds.delete(key)
    console.warn('[routing-session] start-session API failed', err)
  }
  return sessionId
}

export async function notifySpecializedRoutingEditStart(routingId) {
  if (!routingId) return null
  const sessionId = startRoutingSession()
  const key = `specialized:${sessionId}:${routingId}`
  if (notifiedRoutingIds.has(key)) return sessionId
  notifiedRoutingIds.add(key)
  try {
    await startSpecializedRoutingEditSession(routingId, sessionId)
  } catch (err) {
    notifiedRoutingIds.delete(key)
    console.warn('[routing-session] specialized start-session API failed', err)
  }
  return sessionId
}
